/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : ADs : RAIL PLACEMENT : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    rail: {
        animationName: 'fadeInRight',

        '& .visual': {
            '& .device': {
                backgroundImage: `url(${url.image.app}/mks/graphic-placement-rail-large.png)`,
                width: pxToEm(673),
                height: pxToEm(443),
                '& .embed-container': {
                    width: pxToEm(179),
                    top: pxToEm(35),
                    right: pxToEm(85),
                    '& .ad': {
                        '&.inline': {
                            height: pxToEm(113)
                        }
                    },
                    '& .embed': {
                        backgroundImage: `url(${url.image.app}/mks/graphic-embed-profiling-rail.png)`,
                        height: pxToEm(155)
                    }
                }
            }
        }
    }
});